module.exports = __webpack_public_path__ + "img/按钮.4fd962e1.png";